import { fabric } from "fabric";
import { v4 } from 'uuid';

import CanvasHandler from "./CanvasHandler";
import Canvas  from "../components/canvas/Canvas";
import { FabricObject } from "../types/FabricCustomType";
import { Circle } from "fabric/fabric-impl";

class UpdateSeatQuantity {
    canvasHandler: CanvasHandler;
    constructor(canvasHandler: CanvasHandler) {
        this.canvasHandler = canvasHandler;
    }
    updateProperty = (propertyName: string,
        newValue: any,
        allValuesForm: any,
        selectedItem: any,
        canvasRef: Canvas) => {
        // aqui se modifica la propiedad
        if (newValue > selectedItem._objects.length) {
            let remainItems = newValue - selectedItem._objects.length;
            for (let index = 0; index < remainItems; index++) {
                let circle = new fabric.Circle({
                    name: 'New Linear Seat',
                    left: (selectedItem.stepX * (selectedItem._objects.length)) + selectedItem.left,
                    top: (selectedItem.stepY * (selectedItem._objects.length)) + selectedItem.top,
                    originX: 'left',
                    originY: 'top',
                    radius: 7.5,
                    angle: 0,
                    fill: '#cccccc',
                    strokeWidth: 1,
                    stroke: '#727272',
                    transparentCorners: false,
                    hasControls: selectedItem._objects[0].hasControls,
                    hasBorders: selectedItem._objects[0].hasBorders,
                    selectable: selectedItem._objects[0].selectable,
                    lockMovementX: !selectedItem._objects[0].lockMovementX,
                    lockMovementY: !selectedItem._objects[0].lockMovementY,
                    hoverCursor: !selectedItem._objects[0].hoverCursor ? 'pointer' : 'move',
                }) as FabricObject<Circle>;
                circle.set({
                    id: v4(),
                    label: 'Label',
                    displayedLabel: '',
                    container: selectedItem._objects[0].container,
                    editable: false,
                    objectOption: selectedItem._objects[0].objectOption
                });
                selectedItem.addWithUpdate(circle);
            }
            this.canvasHandler.seatQuantity = newValue;
        }
        else {
            let objectToRemove = selectedItem._objects.slice(-1);
            selectedItem.removeWithUpdate(objectToRemove[0]);
        }
        selectedItem.setCoords();
        selectedItem.set(propertyName, newValue);
        canvasRef.canvas.requestRenderAll();
        const { onModified } = this.canvasHandler;
        if (onModified) onModified(selectedItem);
    }
}

export default UpdateSeatQuantity;
